module.exports = __webpack_public_path__ + "static/img/4839_phase_function_Paper_Points.2816273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4839_phase_function_Paper_Points.png
// module id = RgCk
// module chunks = 0